import { PagingResultsViewModel, TUsuarioPerfilViewModel, EnumSiNoTodos, FilterSearchingBaseViewModel } from '../../core/_infrastructure/types/common';
import { RegAgenteControlComunidadAutonomaViewModel, RegAgenteControlViewModel } from '../registros/agentescontrol/agentecontrol.types';
import { RegTecnicoEntidadAuditoraViewModel } from '../registros/entidadesauditoras/entidadauditora.types';
import { RegLaboratorioViewModel, RegTecnicoLaboratorioViewModel } from '../registros/laboratorios/laboratorio.types';

// *** INICIO USUARIOS CEXVEG

export class UsuarioItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: VListaUsuariosItemViewModel[];
}

export class VListaUsuariosItemViewModel {
    public Id: number;
    public Nombre = '';
    public Apellidos = '';
    public NombreUsuarioCexveg = '';
    public Nif = '';
    public Email = '';
    public Activo: boolean;
}

export class FilterSearchingVListaUsuariosViewModel extends FilterSearchingBaseViewModel {
    public Nombre = '';
    public Apellidos = '';
    public Nif = '';
    public IdPerfilUsuario: number | null = null;
    public IdComunidadAutonoma: number | null;
    public IdProvincia: number | null;
    public IdPuntoInspeccion: number | null;
    public NombreUsuarioCexveg = '';
    public Email = '';
    public Activo: number = EnumSiNoTodos.TODOS;
}

//FIN USUARIOS CEXVEG ***

// *** INICIO USUARIOS EXTERNOS

export class UsuarioExternoItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: VListaUsuariosExternosItemViewModel[];
}

export class VListaUsuariosExternosItemViewModel {
    public IdUsuario: number;
    public RazonSocial = '';
    public NombreUsuarioCexveg = '';
    public IdPais: number;
    public IdProvincia: number;
    public IdMunicipio: number;
    public NumeroTelefono = '';
    public NumeroFax = '';
    public CodigoPostal = '';
    public IdTipoVia: number;
    public NombreVia = '';
    public NumeroPortal = '';
    public NifCifRazonSocial = '';
    public FechaCreacion: Date;
    public FechaActivacion: Date;
    public FechaBaja: Date;
    public NombreRepresentante = '';
    public ApellidosRepresentante = '';
    public NifRepresentante = '';
    public LocalidadTraces = '';
}

export class FilterSearchingVListaUsuariosExternosViewModel extends FilterSearchingBaseViewModel {
    public IdPais: number | null = null;
    public IdProvincia: number | null = null;
    public IdMunicipio: number | null = null;
    public LocalidadTraces = '';
    public RazonSocial = '';
    public NifCifRazonSocial = '';
    public Apellidos = '';
    public Nombre = '';
    public Nif = '';
    public NombreUsuarioCexveg = '';
    public Email = '';
    public IdPerfilUsuarioExterno: number | null;
    public Activo: number = EnumSiNoTodos.TODOS;
}

//FIN USUARIOS EXTERNOS ***

// *** INICIO AGENTES CONTROL

export class RegAgenteControlItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: VListaAgentesControlItemViewModel[];
}

export class VListaAgentesControlItemViewModel {
    public IdUsuario: number;
    public Nombre = '';
    public Apellidos = '';
    public Nif = '';
    public Ropo = '';
    public IdCa: number;
    public DescripcionCa = '';
    public Direccion = '';
    public Localidad = '';
    public CodigoPostal = '';
    public Telefono = '';
    public Email = '';
    public Observaciones = '';
    public FechaBaja: Date | null;
    public Activo = true;

    public DisableActivationButton: boolean;
    public TwRegAgenteControlComunidadAutonomaCollection: RegAgenteControlComunidadAutonomaViewModel[];
}

export class FilterSearchingRegAgenteControlViewModel extends FilterSearchingBaseViewModel {
    public IdUsuario: number;
    public Nombre = '';
    public Apellidos = '';
    public Nif = '';
    public Ropo = '';
    public IdCa: number | null;
    public Telefono = '';
    public Email = '';
    public Activo: number = EnumSiNoTodos.TODOS;
    public EsComunidadAutonoma: boolean;
}

//FIN AGENTES CONTROL

// *** INICIO USUARIOS MIGRACIÓN

export class UsuarioMigracionItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: WListaUsuariosMigracionItemViewModel[];
}

export class WListaUsuariosMigracionItemViewModel {
    public Id: number;
    public Nombre = '';
    public Apellidos = '';
    public NombreUsuario = '';
    public NifCas = '';
    public Email = '';
    public Activo = true;
    public IdProvincia: number;
    public IdPerfilUsuario: number;
    public YaMigrado = false;
    public Pendientes = true;
}

export class FilterSearchingWListaUsuariosMigracionItemViewModel extends FilterSearchingBaseViewModel {
    public Nombre = '';
    public Apellidos = '';
    public NombreUsuario = '';
    public NifCas = '';
    public Email = '';
    public IdPerfilUsuario: number | null = null;
    public IdProvincia: number | null = null;
    public Pendientes: number = EnumSiNoTodos.TODOS;
    public Activo = true;
    public YaMigrado = false;
}

//FIN USUARIOS MIGRACIÓN ***

export class UsuarioViewModel {
    constructor() {}

    public Id: number;
    public Activo = false;
    public Nif = '';
    public Nombre = '';
    public Apellidos = '';
    public Email = '';
    public FechaCreacion: Date;
    public FechaActivacion: Date;
    public FechaBaja: Date;
    public NombreUsuarioCexveg = '';
    public TwUsuarioExterno: UsuarioExternoViewModel;
    public TwRegAgenteControl: RegAgenteControlViewModel;
    public TwRegTecnicoEntidadAuditora: RegTecnicoEntidadAuditoraViewModel;
    public TwRegLaboratorio: RegLaboratorioViewModel;
    public TwRegTecnicoLaboratorio: RegTecnicoLaboratorioViewModel;
    public TUsuarioPerfilCollection: TUsuarioPerfilViewModel[];
    public TwUsuarioCa: TwUsuarioCaViewModel;
    public TwUsuarioInspector: TwUsuarioInspectorViewModel;
    public TUsuarioPuntoInspeccionCollection: TUsuarioPuntoInspeccionViewModel[];
}

export class UsuarioExternoViewModel {
    constructor() {}

    public IdUsuario: number;
    public RazonSocial = '';
    public IdPais: number;
    public IdProvincia: number;
    public IdMunicipio: number;
    public NumeroTelefono = '';
    public NumeroFax = '';
    public CodigoPostal = '';
    public IdTipoVia: number;
    public NombreVia = '';
    public NumeroPortal = '';
    public NifCifRazonSocial = '';
    public NombreRepresentante = '';
    public ApellidosRepresentante = '';
    public NifRepresentante = '';
    public LocalidadTraces = '';
}

export class TUsuarioPuntoInspeccionViewModel {
    public IdUsuario: number;
    public IdPuntoInspeccion: number;
    public Descripcion = '';
}

export class TwUsuarioInspectorViewModel {
    public IdUsuario: number;
    public AutorizadoImportacion = true;
    public AutorizadoExportacion = true;
}

export class TwUsuarioCaViewModel {
    public IdUsuario: number;
    public IdCa: number;
    public AutorizadoCertificacionEx = false;
    public AutorizadoCampanias = false;
    public Descripcion = '';
}
